import React from 'react';

// One line of already-settled payment detail (a paid deposit, the remainder).
export function PaymentOption({ className = '', children }) {
  return (
    <p className={`checkout-deposits__line ${className}`.trim()}>
      {children}
    </p>
  );
}
